module.exports = __webpack_public_path__ + "static/Ryan-Vannin-ced3b2e00ea7fa38eafd4b858e1cdce8.jpg";